var Vendd = (function (Vendd) {
    'use strict';

    Vendd.User = (function (User) {

        User.AuthProviders = (function (AuthProviders) {

            var gg = {
                
                connect: function (loginId, email, onSuccess, onError) {
                    Vendd.Service.call({
                        url: 'AuthService.svc/ConnectAuthenticationProvider',
                        data: {
                            provider: 'google',
                            loginId: loginId,
                            email: email
                        },
                        onSuccess: onSuccess,
                        onFailure: onError
                    });
                },

                login: function () {
                    var oauthPopup = window.open('', 'googleLogin', 'status=1,toolbar=0,location=0,menubar=0,directories=0,resizable=0,scrollbars=0,height=550,width=600');
                    Vendd.Service.call({
                        url: 'Auth/GoogleLoginService.svc/GetConfiguration',
                        data: {},
                        onSuccess: function (res) {
                            oauthPopup.location = res.authUrl;
                            oauthPopup.focus();
                        },
                        onFailure: function (ex) {
                            oauthPopup.close();
                            throw ex;
                        }
                    });
                },

                logout: function (cb) {
                    cb();
                }
            };

            AuthProviders.google = {

                initiating: false,
                initiated: false,

                Configuration: {
                    ClientId: '',
                    AuthUrl: ''
                },

                init: function () {
                    var me = this;

                    if (!this.initiating && !this.initiated) {
                        this.initiating = true;

                        (function (d, s, id) {
                            var js,
                                fjs = d.getElementsByTagName(s)[0];
                            if (d.getElementById(id))
                                return;

                            js = d.createElement(s);
                            js.id = id;
                            js.src = "https://apis.google.com/js/platform.js";

                            fjs.parentNode.insertBefore(js, fjs);
                        }(document, 'script', 'google-jssdk'));
                    }
                },
                
                login: function () {
                    gg.login();
                },

                logout: function (cb) {
                    gg.logout(cb);
                }

            };

            return AuthProviders;

        })(User.AuthProviders || {});

        return User;

    })(Vendd.User || {});

    return Vendd;

})(Vendd || {});